export default "__VITE_ASSET__Bbsio0TY__"